import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset viewport to top on every route change so product detail opens at the
 * product hero — not wherever the user scrolled on the listing page.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
